(() => {
  const EVENT_PREFIX = 'coastal_';
  const GA4_DESTINATION = 'G-YTSZ4BE1Z8';
  const SCRIPT_VERSION = '0.3.0';
  const debugState = (window.CoastalFunnelEvents = {
    initialized: false,
    initializedAt: null,
    error: null,
    events: (window.__coastalFunnelEvents = window.__coastalFunnelEvents || []),
    version: SCRIPT_VERSION,
  });

  function productHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function safeSessionId() {
    const key = 'coastal_funnel_session_id';

    try {
      let value = window.sessionStorage.getItem(key);
      if (!value) {
        value = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        window.sessionStorage.setItem(key, value);
      }
      return value;
    } catch (_error) {
      return null;
    }
  }

  function cleanDetail(detail = {}) {
    return Object.fromEntries(
      Object.entries(detail).filter(([, value]) => value !== undefined && value !== null && value !== '')
    );
  }

  function publish(eventName, detail = {}) {
    const payload = cleanDetail({
      event_name: `${EVENT_PREFIX}${eventName}`,
      occurred_at: new Date().toISOString(),
      session_id: safeSessionId(),
      page_type: productHandle() ? 'product' : 'other',
      page_path: window.location.pathname,
      product_handle: productHandle(),
      script_version: SCRIPT_VERSION,
      ...detail,
    });

    debugState.events.push(payload);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (_error) {
      // Analytics must never interrupt shopping behavior.
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('event', payload.event_name, {
        send_to: GA4_DESTINATION,
        coastal_session_id: payload.session_id,
        page_path: payload.page_path,
        product_handle: payload.product_handle,
        variant_id: payload.variant_id,
        quantity: payload.quantity,
        source: payload.source,
        error_message: payload.error_message,
        cart_item_count: payload.cart_item_count,
        cart_total_price: payload.cart_total_price,
        script_version: payload.script_version,
        debug_mode: window.Shopify?.theme?.role === 'unpublished',
      });
      payload.ga4_destination = GA4_DESTINATION;
      payload.ga4_queued = true;
    } catch (_error) {
      payload.ga4_queued = false;
    }

    try {
      window.Shopify?.analytics?.publish(payload.event_name, payload);
    } catch (_error) {
      // Customer Events may be unavailable until consent or pixel setup is complete.
    }

    try {
      document.dispatchEvent(new CustomEvent('coastal:funnel-event', { detail: payload }));
    } catch (_error) {
      // The DOM event is only a preview/debugging aid.
    }
  }

  function isAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = form.getAttribute('action') || '';
    return action.includes('/cart/add') || Boolean(form.closest('product-form'));
  }

  function addToCartDetail(form) {
    if (!form) return {};
    const formData = new FormData(form);
    return {
      variant_id: formData.get('id'),
      quantity: Number(formData.get('quantity') || 1),
    };
  }

  function initialize() {
    document.addEventListener(
      'submit',
      (event) => {
        if (!isAddToCartForm(event.target)) return;
        publish('add_to_cart_attempted', addToCartDetail(event.target));
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest?.('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
        if (!button) return;
        const form = button.closest('form') || button.closest('product-form')?.querySelector('form');
        publish('add_to_cart_button_clicked', addToCartDetail(form));
      },
      true
    );

    document.addEventListener('variant:add', (event) => {
      publish('add_to_cart_succeeded', {
        variant_id: event.detail?.variant?.id,
        quantity: event.detail?.quantity,
        source: event.detail?.sectionId,
      });
    });

    document.addEventListener('cart:error', (event) => {
      publish('add_to_cart_failed', {
        variant_id: event.detail?.productVariantId,
        source: event.detail?.source,
        error_message: event.detail?.message || event.detail?.errors,
      });
    });

    document.addEventListener('cart:change', (event) => {
      publish('cart_changed', {
        cart_item_count: event.detail?.cart?.item_count,
        cart_total_price: event.detail?.cart?.total_price,
        source: event.detail?.sectionId,
      });
    });

    debugState.initialized = true;
    debugState.initializedAt = new Date().toISOString();
    document.documentElement.dataset.coastalFunnel = 'initialized';

    if (productHandle()) publish('product_viewed');
  }

  try {
    initialize();
  } catch (error) {
    debugState.error = error instanceof Error ? error.message : String(error);
    document.documentElement.dataset.coastalFunnel = 'error';
  }
})();
